import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class OrdemServicosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaStatusNF, buscaSitFin } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/notas_fiscais', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    usuario: buscaUsuario.key,
                    sitFin: String(buscaSitFin.key),
                    sitVen: String(buscaStatusNF.key),
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderSitFinanc = (sit) => {
        return (
            <span> {sit === 'P' ? 'PAGO' : 'ABERTO'} </span>
        );
    };

    renderModelo = (nfe, registro) => {
        return (
            <span> {nfe === 55 ? 'NFe' : nfe === 65 ? 'NFCe' : 'Serv'} </span>
        );
    };



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Notas Fiscais
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde NF: </span>
                                <span>{this.props.qtdeOS}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Total: </span>
                                <span>R$ {this.renderValor(this.props.totalOS)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.os_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="nf_dt_emissao"
                                dataIndex="nf_dt_emissao"
                                title="Emissão"
                                render={this.renderData}
                                width={80}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="enf_cnpj"
                                dataIndex="enf_cnpj"
                                title="Emitente"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="nf_tipo"
                                dataIndex="nf_tipo"
                                title="Tipo"
                                width={50}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="nf_modelo"
                                dataIndex="nf_modelo"
                                title="Mod"
                                render={this.renderModelo}
                                width={50}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="nf_numero"
                                dataIndex="nf_numero"
                                title="Número"
                                width={50}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Remet/Dest"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="nf_vlr_total"
                                dataIndex="nf_vlr_total"
                                title="Valor"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="situacao_titulo"
                                dataIndex="situacao_titulo"
                                title="Sit. Financ."
                                render={this.renderSitFinanc}
                                width={90}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="situacao_nota"
                                dataIndex="situacao_nota"
                                title="Situação"
                                width={90}
                                align="center"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default OrdemServicosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/NotasFiscaisEmissaoPrintModal.js